import React from "react";
import styled from "styled-components";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import toast from "react-hot-toast";
import { QUERY_KEYS } from "constant/react_query";
import { PositionResult } from "common/position/dto/PositionResult";
import { positionFormDefaultValuesGet } from "common/position/position_form_common";
import { useSakusasPositionUpdate } from "hooks/sakusas/position/useSakusasPositionUpdate";
import PositionForm from "components/common/position/PositionForm";
import PositionSingleNav from "components/common/position/PositionSingleNav";

type PositionEditProps = {
  position: PositionResult;
};

const PositionEdit = ({ position }: PositionEditProps) => {
  const { handleSubmit, reset, control, setValue } = useForm({
    defaultValues: positionFormDefaultValuesGet(position),
  });
  const { positionUpdateMutate } = useSakusasPositionUpdate({
    invalidateKeys: [QUERY_KEYS.SAKUSAS_POSITION_SEARCH],
  });

  const onSubmit = async (data: any) => {
    console.log(data);
    const { datum, title, fileName } = data;
    console.log("datum", datum);
    positionUpdateMutate({
      id: position.id,
      updatePayload: { datum, title, fileName },
    });
    toast.success("Position updated");
  };

  return (
    <DivPosition>
      <PositionForm
        control={control}
        onSubmit={onSubmit}
        handleSubmit={handleSubmit}
        reset={reset}
        defaultValues={positionFormDefaultValuesGet(position)}
        setValue={setValue}
      />
      <DivNav>
        <PositionSingleNav position={position} hideEditNav={true} />
      </DivNav>
    </DivPosition>
  );
};

const DivPosition = styled.div`
  display: flex;
  flex-direction: column;
`;

const DivNav = styled.div`
  margin-top: 1rem;
`;

export default PositionEdit;
